import React from 'react'
import styles from './PopupCoin.module.css';
import Link from 'next/link';

function LoginPopup() {
  return (
    <div className={styles.dfx_coinWrapper}>
      <div className={`${styles.dfx_coinPopupOverlay} ${styles.dfx_loginPopup}`}>
        <div className={`${styles.dfx_coinPopupBox} ${styles.dfx_coinBonusContainer} ${styles.dfx_loginPopupBox}`}>
          <div className={styles.dfx_loginPopupIcon}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="./loginPopUp.webp" alt="LoginPopUp" />
          </div>
          <div className={styles.dfx_coinPopupBody}>
            <h2 className={styles.dfx_coinPopupContent}>Please Log In to Continue</h2>
            <p className={styles.dfx_coinPopupDesc}>Rewards are linked to your account so your progress stays safe.</p>
            <p className={styles.dfx_coinPopupDesc}>Sign in to access your rewards.</p>
            <div className={styles.dfx_coinPopupBtn}>
              <Link href="/login" className={styles.dfx_coinPopupClaimButton}>Log In</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginPopup
